import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import type { PluginListenerHandle } from '@capacitor/core';

function cleanup(handles: PluginListenerHandle[]) {
  handles.forEach((handle) => {
    void handle.remove();
  });
}

export async function signInWithGoogleNative(): Promise<string> {
  await FirebaseAuthentication.signInWithGoogle();
  const { token } = await FirebaseAuthentication.getIdToken();
  if (!token) throw new Error('Google sign-in did not return an ID token.');
  return token;
}

export async function sendPhoneOtpNative(phoneNumber: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const handles: PluginListenerHandle[] = [];
    let settled = false;

    const finish = (fn: () => void) => {
      if (settled) return;
      settled = true;
      cleanup(handles);
      fn();
    };

    FirebaseAuthentication.addListener('phoneCodeSent', (event) => {
      finish(() => resolve(event.verificationId));
    }).then((handle) => handles.push(handle));

    FirebaseAuthentication.addListener('phoneVerificationFailed', (event) => {
      finish(() => reject(new Error(event.message || 'Phone verification failed.')));
    }).then((handle) => handles.push(handle));

    FirebaseAuthentication.addListener('phoneVerificationCompleted', () => {
      finish(() => resolve('__AUTO__'));
    }).then((handle) => handles.push(handle));

    FirebaseAuthentication.signInWithPhoneNumber({ phoneNumber }).catch((err) => {
      finish(() => reject(err instanceof Error ? err : new Error('Failed to start phone verification.')));
    });
  });
}

export async function verifyPhoneOtpNative(verificationId: string, verificationCode: string): Promise<string> {
  if (verificationId === '__AUTO__') {
    const { token } = await FirebaseAuthentication.getIdToken();
    if (!token) throw new Error('Phone sign-in did not return an ID token.');
    return token;
  }

  await FirebaseAuthentication.confirmVerificationCode({ verificationId, verificationCode });
  const { token } = await FirebaseAuthentication.getIdToken();
  if (!token) throw new Error('Phone sign-in did not return an ID token.');
  return token;
}
